import React, { useState, useEffect } from "react";
import axios from "axios";
import ForecastDay from "./ForecastDay";

export default function Forecast(props) {
  const [loaded, setLoaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  function handleResponse(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  useEffect(() => {
    setLoaded(false);

    const apiKey = "b2a5adcct04b33178913oc335f405433";
    const apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.city}&key=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);

  }, [props.city]);

  if (loaded) {
    return (
      <div className="Forecast row">
        {forecast.slice(0,5).map(function(dailyForecast, index) {
          return (
            <div className="col" key={index}>
              <ForecastDay data={dailyForecast} />
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
}